import React from "react";
import { useViewerQuery } from "queries/viewerQuery";
import { MAX_FREE_AI_MESSAGES, MAX_SUBSCRIBER_AI_MESSAGES } from "sharedJs__generated/constants";
import { dispatchEvent, EVENT } from "../../tools/events";
import { ASSISTANT_HASH, AssistantOpenSettings } from "./AssistantPopup";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsQuestListenVocab } from "root/main/main/quests/ListenVocabQuest";

export function useOpenAssistant() {
  return React.useCallback((settings?: AssistantOpenSettings) => {
    dispatchEvent(EVENT.resetAssistant);
    dispatchEvent(EVENT.openAssistant, settings || {});
  }, []);
}

export function useCloseAssistant(): () => void {
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen = location.hash === ASSISTANT_HASH;
  return React.useCallback(() => {
    if (isOpen) {
      navigate({ hash: "" }, { replace: true });
      dispatchEvent(EVENT.assistantClosed);
    }
  }, [navigate, isOpen]);
}

export function useRemainingAiMessages(): number {
  const { viewer, isSubscriber } = useViewerQuery();
  const maxAiMessages = isSubscriber ? MAX_SUBSCRIBER_AI_MESSAGES : MAX_FREE_AI_MESSAGES;
  const remainingMessages = maxAiMessages - (viewer?.aiMessagesUsedThisWeek || 0);
  const activeListenVocabQuest = useIsQuestListenVocab();
  const additionalMessages = activeListenVocabQuest && remainingMessages <= 0 ? 3 : 0; // 3 additional messages for listen vocab quest
  // in case a subscription expires, or we change MAX_SUBSCRIBER_AI_MESSAGES or MAX_FREE_AI_MESSAGES
  return Math.max(0, remainingMessages + additionalMessages);
}
